import type { Messages } from './en';

/** Contingut de la fase 2: llocs nous (poliesportiu, centre comercial, quadres, infermeria, aula de música) i la seva gent. */
export const caPlaces: Pick<Messages, 'places' | 'talks2'> = {
  places: {
    zones: {
      gym: 'Gimnàs', pool: 'Piscina', nurse: 'Infermeria', music: 'Aula de música', cafe: 'Cafeteria Fanalet',
      giftShop: 'Botiga de regals', dept: 'Grans magatzems', restaurant: 'Restaurant', mall: 'Centre Comercial Fanalet',
      sportsCenter: 'Poliesportiu', tennis: 'Pista de tennis', volley: 'Vòlei platja', stable: 'Quadres',
    },
    mapNames: { sports: 'Poliesportiu', mall: 'Centre Comercial Fanalet' },
    objects: {
      nurseDesk: 'Taula de la infermera', pool: 'Piscina', gymNet: 'Xarxa de vòlei', tennisNet: 'Pista de tennis', volleyNet: 'Pista de vòlei',
      fountain: 'Font', cafeCounter: 'Taulell de la cafeteria', giftCounter: 'Taulell de regals', deptCounter: 'Caixa', restCounter: 'Taulell del restaurant',
    },
    npc: {
      nurse: 'La infermera Hsieh', musicTeacher: 'El professor Kuo', lifeguard: 'La socorrista Ann', barista: 'La Mei', giftClerk: 'La Lulu',
      deptClerk: 'El senyor Pan', waiter: 'En Tom', stableKeeper: 'L’oncle Wu', horse: 'Cavall', pony: 'Poni',
    },
    items: {
      flowers: { name: 'Ram de flors', desc: 'Un regal que fa somriure qualsevol.' },
      scarf: { name: 'Bufanda', desc: 'Un regal suau i calentó.' },
      keychain: { name: 'Clauer bufó', desc: 'Un petit regal per a un amic.' },
      toy: { name: 'Cotxet de joguina', desc: 'Als nens els encanta.' },
      sandwich: { name: 'Entrepà', desc: 'Menjar: +14 d’energia' },
      cocoa: { name: 'Xocolata per emportar', desc: 'Beure: +12 d’energia, +4 d’ànim' },
    },
    shops: {
      cafe: { title: '☕ Cafeteria Fanalet', hint: 'Begudes calentes i berenars.' },
      gift: { title: '🎁 Botiga de regals', hint: 'Els regals fan feliç la gent. Dona’ls quan xerris amb algú!' },
      dept: { title: '👕 Grans magatzems', hint: 'La roba nova et canvia el look a l’instant.' },
    },
    outfits: ['Uniforme de l’escola', 'Dessuadora blau cel', 'Vestit de cireres', 'Esportiu vermell', 'Verd bosc'],
    outfitOn: (name: string) => `Portes: ${name}`,
    restaurant: {
      title: '🍜 Carta del restaurant',
      hint: 'Seu i fes un bon àpat (+energia, +ànim).',
      dishes: [
        { name: 'Sopa de fideus amb vedella', desc: '+35 d’energia' },
        { name: 'Raviolis xinesos (10)', desc: '+30 d’energia, +5 d’ànim' },
        { name: 'Arròs fregit amb verdures', desc: '+28 d’energia, +3 d’estudi (menjar per al cervell!)' },
      ],
      eaten: (d: string) => `Mmm! T’has cruspit: ${d}.`,
      full: 'Estàs massa ple per menjar un altre àpat avui.',
    },
    nurse: {
      text: 'La infermeria fa olor de llençols nets i d’espígol.',
      checkup: 'Fer-te una revisió (+energia)',
      checkupDone: 'La infermera Hsieh et pren la temperatura. «Tot bé! Descansa una mica i beu aigua.»',
      bandage: 'Preguntar pels primers auxilis',
      bandageText: 'Per a un tall petit: renta’l amb aigua neta, prem suaument perquè deixi de sagnar i després tapa’l amb una tireta. Si és profund, digues-ho a un adult!',
      already: 'Avui ja t’has fet una revisió. Cuida’t!',
    },
    pool: {
      text: 'L’aigua brilla sota la claraboia. La socorrista vigila.',
      swim: 'Nedar uns quants llargs (−energia, +ànim)',
      swimDone: 'Xof! Has nedat deu llargs. Et sents fort i ben fresc!',
      tired: 'Estàs massa cansat per nedar amb seguretat. Primer descansa!',
      rules: 'Normes de la piscina',
      rulesText: '1. Dutxa’t abans de nedar. 2. No corris per la vora. 3. Neda amb un company. 4. Fes cas a la socorrista.',
    },
    rally: {
      tennis: 'Peloteig de tennis',
      volley: 'Entrenament de vòlei',
      text: 'Que ve la pilota! On caurà?',
      left: 'Esquerra', center: 'Centre', right: 'Dreta',
      hit: 'Quina tornada!',
      miss: 'T’ha passat! Mira bé la pilota…',
      done: (n: number) => `Fi del peloteig: ${n}/3 bons cops!`,
    },
    fountain: {
      text: 'Al fons de la font hi brillen monedes.',
      wish: 'Llançar una moneda i demanar un desig (1🪙)',
      wishDone: 'Plinc! Demanes un desig per a la teva família i els teus amics.',
      noCoin: 'No tens cap moneda.',
    },
    horse: {
      text: 'Un cavall molt manyac t’acarona la mà amb el morro.',
      ride: 'Muntar a cavall (amb el casc posat!)',
      dismount: 'Baixar del cavall',
      riding: 'Ja vas a cavall! Explora el tancat.',
      leave: 'El cavall s’atura a la tanca. Els passejos són només dins del tancat.',
      feed: 'Donar-li una pastanaga (+ànim)',
      fed: 'Cruix, cruix! El cavall sembla feliç de debò.',
    },
    scenarios: {
      swim: 'Preguntar per les normes de la piscina', tennis: 'Aprendre a servir a tennis', horse: 'Muntar a cavall amb seguretat',
      clothes: 'Comprar roba', music: 'Anar a classe de música', art: 'Parlar del teu dibuix',
    },
    gifts: {
      give: '🎁 Fer un regal',
      pick: 'Quin regal?',
      thanks: ['Oh! Per a mi? Moltíssimes gràcies!', 'Que n’ets, de detallista! M’encanta!', 'Quina sorpresa més bonica!'],
    },
  },
  /** Xerrades dels personatges nous (mateixa forma que `talks`). */
  talks2: {
    nurse: {
      greet: { morning: ['Bon dia! Et trobes bé?'], afternoon: ['Hola, bonic. Necessites res?'], evening: ['Encara per aquí? No t’oblidis de descansar.'] },
      topics: [
        {
          say: 'Saps per què és tan important dormir?',
          choices: [
            { t: 'Ajuda el meu cos a créixer i a curar-se.', reply: 'Exacte! I el cervell endreça tot el que has après.' },
            { t: 'Quantes hores hauria de dormir?', reply: 'Unes nou o deu hores, a la teva edat.' },
            { t: 'I si dormo a classe?', reply: 'Ha, ha! De nit a dormir, i a classe a aprendre.' },
          ],
        },
        {
          say: 'Rentar-se les mans és la manera més fàcil d’estar sa.',
          choices: [
            { t: 'Me les rentaré abans de menjar!', reply: 'Quin bon costum. Vint segons amb sabó!' },
            { t: 'Per què vint segons?', reply: 'És el temps que necessita el sabó per desfer els microbis.' },
            { t: 'Cantaré una cançó mentre me les rento.', reply: 'Perfecte: «Per molts anys» dues vegades són uns vint segons!' },
          ],
        },
      ],
    },
    musicTeacher: {
      greet: { morning: ['Bon dia! Fem música?'], afternoon: ['Ah, arriba un músic!'], evening: ['Una última cançó abans d’anar cap a casa?'] },
      topics: [
        {
          say: 'La música és com un idioma. Tothom la pot aprendre.',
          choices: [
            { t: 'Vull aprendre a tocar el piano!', reply: 'Fantàstic. Comença amb una mà, a poc a poc.' },
            { t: 'Quin instrument vas aprendre primer?', reply: 'La flauta dolça! Xisclava una mica, però me l’estimava molt.' },
            { t: 'Puc aprendre la bateria? Fort?', reply: 'Ha, ha, sí. Primer el ritme i després el volum.' },
          ],
        },
        {
          say: 'Cantes quan estàs content?',
          choices: [
            { t: 'Sí! Així encara em sento millor.', reply: 'Diuen que la música duplica l’alegria.' },
            { t: 'Cantar ajuda quan estic trist?', reply: 'Sovint, sí. Les cançons suaus calmen el cor.' },
            { t: 'Només a la dutxa.', reply: 'La dutxa té la millor acústica!' },
          ],
        },
      ],
    },
    lifeguard: {
      greet: { morning: ['Neda matinal? Primer escalfa!'], afternoon: ['Avui l’aigua està perfecta.'], evening: ['Últims llargs i cap a casa!'] },
      topics: [
        {
          say: 'No nedis mai sol, encara que nedis molt bé.',
          choices: [
            { t: 'Entesos. Sempre amb un company!', reply: 'Aquesta és la norma. La seguretat, primer.' },
            { t: 'I si algú necessita ajuda?', reply: 'Crida un adult o la socorrista i llança-li alguna cosa que suri. No t’hi llancis!' },
            { t: 'El meu aneguet de goma pot ser el meu company?', reply: 'Ha! Només compten els companys humans.' },
          ],
        },
      ],
    },
    barista: {
      greet: { morning: ['Bon dia! Tenim croissants acabats de fer!'], afternoon: ['Benvingut a la Cafeteria Fanalet!'], evening: ['Bona tarda! Descafeïnat per als grans i xocolata per a tu.'] },
      topics: [
        {
          say: 'Kai, el de la botiga de la cantonada, em va ajudar a obrir aquesta cafeteria!',
          choices: [
            { t: 'Que bé! S’hi està tan a gust, aquí.', reply: 'Gràcies! Hem posat una planta a cada taula.' },
            { t: 'Quina és la teva beguda preferida?', reply: 'Xocolata calenta amb una mica de canyella.' },
            { t: 'Hi ha una carta secreta?', reply: 'Pst… demana l’«Especial Fanalet». Porta núvols de sucre.' },
          ],
        },
      ],
    },
    giftClerk: {
      greet: { morning: ['Hola! Busques un regal?'], afternoon: ['Benvingut! T’ho emboliquem tot gratis.'], evening: ['Un regal d’última hora? T’ajudo!'] },
      topics: [
        {
          say: 'Els millors regals demostren que has pensat de debò en algú.',
          choices: [
            { t: 'Triaré una cosa que li agradi de veritat.', reply: 'Aquest és el secret. Escolta què li agrada a la gent.' },
            { t: 'Què és el que compra més la gent?', reply: 'Flors per a les mares i clauers per als amics.' },
            { t: 'Puc fer-me un regal a mi mateix?', reply: 'Ha, ha, de tant en tant! Fes-te un caprici.' },
          ],
        },
      ],
    },
    deptClerk: {
      greet: { morning: ['Bon dia. Temporada nova, estils nous!'], afternoon: ['Benvingut. Emprova’t el que vulguis!'], evening: ['Tanquem a les nou.'] },
      topics: [
        {
          say: 'Posa’t allò que et faci sentir còmode i segur.',
          choices: [
            { t: 'M’agraden els colors vius!', reply: 'Doncs el vestit de cireres o el conjunt esportiu vermell!' },
            { t: 'Què es porta aquest any?', reply: 'Les dessuadores. Suaus, calentes i amb butxaques.' },
            { t: 'Teniu capes de superheroi?', reply: 'Doncs no, quina pena. De moment.' },
          ],
        },
      ],
    },
    waiter: {
      greet: { morning: ['Obrim a les onze, però passa, passa!'], afternoon: ['Taula per a un?'], evening: ['Bon vespre! Avui hi ha molta feina.'] },
      topics: [
        {
          say: 'El brou dels nostres fideus amb vedella es fa durant sis hores.',
          choices: [
            { t: 'Uau, per això són tan bons!', reply: 'Gràcies! El cuiner n’estarà orgullós.' },
            { t: 'Què més és bo, aquí?', reply: 'Els raviolis. Els pleguem a mà cada matí.' },
            { t: 'Puc menjar primer les postres?', reply: 'Només si em promets que després et menjaràs la verdura!' },
          ],
        },
      ],
    },
    stableKeeper: {
      greet: { morning: ['Bon dia! Els cavalls tenen gana.'], afternoon: ['Vols saludar els cavalls?'], evening: ['És hora que els cavalls descansin.'] },
      topics: [
        {
          say: 'Acosta’t sempre a un cavall pel costat, perquè et pugui veure.',
          choices: [
            { t: 'Seré suau i estaré tranquil.', reply: 'Molt bé. Els cavalls noten si estàs nerviós.' },
            { t: 'Què els agrada menjar, als cavalls?', reply: 'Fenc, pastanagues i pomes. Xocolata, mai!' },
            { t: 'Els cavalls poden parlar?', reply: 'Amb les orelles! Orelles endavant vol dir que tenen curiositat.' },
          ],
        },
      ],
    },
  },
};
